import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

interface Props {
  achievements: string[];
  onUpdate: (achievements: string[]) => void;
}

export default function AchievementList({ achievements, onUpdate }: Props) {
  const addAchievement = () => {
    onUpdate([...achievements, '']);
  };

  const updateAchievement = (index: number, value: string) => {
    const updated = [...achievements];
    updated[index] = value;
    onUpdate(updated);
  };

  const removeAchievement = (index: number) => {
    onUpdate(achievements.filter((_, i) => i !== index));
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-3">
        Achievements & Activities
        <span className="block mt-1 text-sm font-normal text-gray-500">
          Add relevant academic achievements, honors, extracurricular activities, and leadership roles
        </span>
      </label>
      {achievements.map((achievement, index) => (
        <div key={index} className="flex gap-2 mb-3">
          <textarea
            value={achievement}
            onChange={(e) => updateAchievement(index, e.target.value)}
            placeholder="Describe your achievement or activity..."
            className="flex-1 min-h-[80px] px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 border-gray-300 resize-y"
            rows={3}
          />
          <button
            onClick={() => removeAchievement(index)}
            className="flex-shrink-0 text-red-500 hover:text-red-600"
            title="Remove achievement"
          >
            <Trash2 className="h-5 w-5" />
          </button>
        </div>
      ))}
      <button
        onClick={addAchievement}
        className="mt-4 w-full py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-teal-500 hover:text-teal-600 flex items-center justify-center gap-2 transition-colors"
      >
        <Plus className="h-4 w-4" />
        Add Achievement
      </button>
    </div>
  );
}